import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { MultiSelectFilterPicker } from 'seagull';
export function ProposalsSentByFilterPicker(props) {
    const { onChange, value, possibleValues } = props;
    const counts = useMemo(()=>Array.from(new Set(Object.keys(possibleValues))).reduce((acc, id)=>Object.assign(acc, {
                [id]: Object.keys(possibleValues).filter((e)=>e === id).length
            }), {}), [
        possibleValues
    ]);
    const options = useMemo(()=>{
        return Object.keys(counts).sort((valueA, valueB)=>{
            if (valueA === valueB) {
                return 0;
            } else if (valueA > valueB) {
                return 1;
            } else {
                return -1;
            }
        }).map((id)=>{
            return {
                label: possibleValues[id],
                value: id
            };
        });
    }, [
        counts,
        possibleValues
    ]);
    return /*#__PURE__*/ _jsx(MultiSelectFilterPicker, {
        testId: 'proposals-sent-by-filter-picker',
        value: value,
        label: "Sent by",
        options: options,
        onChange: onChange
    });
}
